import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

import { formatValue, formatPercentage } from "./Utils.js";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../tailwind.config.js";

const colors = resolveConfig(tailwindConfig).theme.colors;



export const Alert = (props) => {
	const {  value, format, backgroundColor, description } = props;

	let width = "w-[375px]";

	// Container for relative positioning
	return (
		<div className="relative inline-block group pr-6">
			{/* Icon always visible */}
			<div className="text-warning text-2xl ml-2 pt-1 cursor-pointer">
				<FontAwesomeIcon
					icon={icon({ name: "triangle-exclamation", style: "solid" })}
					className="mr-2"
				/>
			</div>
			{/* Floating alert, shown on hover */}
			<div
				className={`absolute right-8 top-1 z-50 ${width} h-[80px] p-2 my-4 rounded-card mr-8 cursor-default shadow-lg transition-all duration-300 ease-in-out transform opacity-0 scale-95 pointer-events-none group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto`}
				style={{ backgroundColor: colors[backgroundColor || "primary-soft"] }}
			>
				<div className="flex flex-row">
					<div className="text-warning text-2xl ml-2 pt-1">
						<FontAwesomeIcon
							icon={icon({ name: "triangle-exclamation", style: "solid" })}
							className="mr-2"
						/>
					</div>
					<div className="flex flex-col">
						<div className="flex flex-row">
							<div className="text-text ml-2">
								<span className="text-sm font-semibold">{format === "percentage" ? formatPercentage(value, false) : formatValue(value, format, false)} </span>
								<span className="text-sm">{description}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

